<template>
  <div data-test="jyre-recommends-page" class="home-page text-big" v-if="!!user">
    <div class="center-flex">
      <div class="homepage-content-container">
        <HomePageHeader :first-name="user.firstName" />
        <SmartSearchBar @run="goToJyreRecommends" :question="userQuery" />
        <br />
        <SmartSearch :query="userQuery" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useRoute } from "vue-router";
import { UserDetailsApiModel } from "../api-models";
import { csContext } from "../services/cs-context";
import HomePageHeader from "../components/home-page-header.vue";
import SmartSearchBar from "../components/smart-search/smart-search-bar.vue";
import SmartSearch from "../components/smart-search/smart-search.vue";

const route = useRoute();

const user = ref<UserDetailsApiModel>(csContext.user);
const userQuery = ref<string>(route.query.question as string);

function goToJyreRecommends(query: string): void {
  const encodedQueryString = encodeURIComponent(query);
  window.location.href = `/jyrerecommends?question=${encodedQueryString}`;
}
</script>

<style scoped lang="less">
@import (reference) "../styles/bootstrap/variables.less";
@import "../styles/home-pages/home-pages";
</style>
